// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.block-link {
  border: 1px solid grey;
  padding: 1px;
  margin: 2px;
}

.icon-sprite {
  width: 64px;
  height: 64px;
  scale: 0.4;
  margin: -18px;
  border: 0;
  display: inline-block;
  vertical-align: middle;
}

.item-list td:first-child {
  text-align: right;
  padding: 5px;
}

.wtb > tr > td {
  vertical-align: top;
  border-bottom: 1px solid white;
  padding-bottom: 1em;
  padding-top: 1em;
}

.wtb th {
  text-align: center;
}

.ltn-health-red {
  color: red;
}

.ltn-health-yellow {
  color: yellow;
}

.ltn-health-green {
  color: green;
}

.ltn-avail > tr > td {
  padding: 0.3em 0.5em;
}

.ltn-avail {
  margin-bottom: 1em;
}

.ltn-avail > tr > th:last-child {
  text-align: left;
  padding-left: 15px;
}

.ltn-avail > tr > th
{
  font-size: 50%;
  text-align: center;
}

.ltn-avail > tr > td:last-child,
.ltn-avail-block > tr > td:last-child
{
  text-align: left;
}

.ltn-avail > tr > td,
.ltn-avail-block > tr > td {
  text-align: right;
  padding-left: 5px;
}

.ltn-avail-block > tr > th {
  padding-top: 15px;
  padding-bottom: 10px;
}

.ltn-tree__header h3 {
  padding-top: 4em;
  padding-bottom: 1em;
  border-bottom: 1px solid white;
}

.ltn-tree__tile {
  padding-bottom: 5px;
  padding-top: 5px;
  border-bottom: 1px solid white;
}

.ltn-tree__tile--naughty {
  background-color: #420000;
}

.prod-stats td, .prod-stats th {
  text-align: right;
}

.gps-link-button img {
  max-width: 18px;
  max-height: 25px;
  cursor: pointer;
  margin-right: 8px;
}

.slippy {
  height: 80vh;
  width: 100%;
  background: black;
}

.slippy--time-range {
  width: 100%;
  padding: 3px;
  margin-top: 1em;
}

.slippy--time-range ol {
  width: 100%;
  list-style-type: none;
  padding-left: 0;
  margin-bottom: 0;
}

.slippy--time-range ol li {
  display: inline-block;
  border: 1px solid #888;
  border-radius: 3px;
  background-color: white;

}

.slippy--time-range-bar li {
  cursor: pointer;
  user-select: none;
  overflow: hidden;
  text-align: center;
}

.slippy--time-range-legend {
  color: black;
  text-align: center;
  margin-top: 0;
  white-space: nowrap;
  text-overflow: clip;
}

.slippy--time-range-help {
  margin-top: 1em;
}

.slippy--time-range-table td {
  vertical-align: middle;
}

.slippy--time-range-table td:nth-child(1) {
  white-space: nowrap;
}

.slippy--time-range-table td:nth-child(3),
.slippy--time-range-table th:nth-child(3) {
  text-align: right;
}

.slippy--time-range-table--picked {
  background-color: #3a4753;
}

.slippy--time-range-help--instructions div {
  vertical-align: middle;
  margin: auto;
  text-align: center;
}


.block-thumb {
  height: 140px;
  width: 204px;
  background: black;
  cursor: pointer;
}

.amount {
  display: inline-block;
  text-align: right;
  min-width: 2.2em;
}

.ul-none {
  list-style-type: none;
  padding-left: 0;
}

.avail-icon {
  width: 24px;
  height: 24px;
  vertical-align: middle;
  margin-right: 0.5em;
}

.big-boy {
  height: 8em;
  font-family: monospace;
  font-size: small;
}

.current-chain-ul > li {
  margin-top: 1em;
}

.chestify-summary > thead > tr > th:nth-child(2),
.chestify-summary > thead > tr > th:nth-child(3),
.chestify-summary > tbody > tr > td:nth-child(2),
.chestify-summary > tbody > tr > td:nth-child(3),
.chestify-summary > tbody > tr > td:nth-child(4)
{
  text-align: right;
}

.chestify-banned > td {
  text-decoration: line-through;
  font-style: italic;
}

.plan-number-table {
  width: 100%;
}

.plan-table-col {
  min-height: 18em;
}

.plan-number-table > tbody > tr > td:nth-child(1)
{
  text-align: right;
}

.plan-number-table > tbody > tr > td:nth-child(3)
{
  text-align: right;
  font-size: small;
}

.plan-number-table--risky {
  color: #bebe00;
}

.plan-number-table--naughty {
  color: #be0000;
}

.busy-trains-table tr td {
  text-align: right;
}

.busy-trains-table tr td:nth-child(1) {
  text-align: left;
}

.busy-trains-table--risky {
  background-color: #440 !important;
}

.busy-trains-table--naughty {
  background-color: #400 !important;
}

.station-config tr td {
  text-align: right;
}

.station-config tr td:nth-child(1) {
  text-align: left;
}

.station-config th {
  top:0;
  background: var(--bs-body-bg);
  position: sticky;
}

.station-config--naughty {
  background-color: #400 !important;
}

.station-config-sorter {
  cursor: pointer;
}

.station-config label {
  white-space: nowrap;
}

.station-config-sorter:hover {
  text-decoration: underline;
}

.station-config-sorter-active {
  text-decoration: underline;
}

.build-speed th, .build-speed td {
  text-align: right;
  padding-left: 0.3em;
}

.action-pill {
  color: inherit;
  text-decoration: none;
  background: #333;
}

.date-picker-form {
  margin: 1em;
}

.date-picker-form label {
  margin-right: 0.5em;
}

.date-picker-input {
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  background-color: var(--bs-form-control-bg);
  background-clip: padding-box;
  border: var(--bs-border-width) solid var(--bs-border-color);
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border-radius: 0.375rem;
  transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
  margin-left: 4px;
}
`, "",{"version":3,"sources":["webpack://./web/main.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;EACb,SAAS;EACT,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;EACd,kBAAkB;AACpB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;;AAEzB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;;;AAGA;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;;;EAME,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,KAAK;EACL,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;EAC3B,2CAA2C;EAC3C,4BAA4B;EAC5B,2DAA2D;EAC3D,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;EACvB,qEAAqE;EACrE,gBAAgB;AAClB","sourcesContent":[".block-link {\n  border: 1px solid grey;\n  padding: 1px;\n  margin: 2px;\n}\n\n.icon-sprite {\n  width: 64px;\n  height: 64px;\n  scale: 0.4;\n  margin: -18px;\n  border: 0;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.item-list td:first-child {\n  text-align: right;\n  padding: 5px;\n}\n\n.wtb > tr > td {\n  vertical-align: top;\n  border-bottom: 1px solid white;\n  padding-bottom: 1em;\n  padding-top: 1em;\n}\n\n.wtb th {\n  text-align: center;\n}\n\n.ltn-health-red {\n  color: red;\n}\n\n.ltn-health-yellow {\n  color: yellow;\n}\n\n.ltn-health-green {\n  color: green;\n}\n\n.ltn-avail > tr > td {\n  padding: 0.3em 0.5em;\n}\n\n.ltn-avail {\n  margin-bottom: 1em;\n}\n\n.ltn-avail > tr > th:last-child {\n  text-align: left;\n  padding-left: 15px;\n}\n\n.ltn-avail > tr > th\n{\n  font-size: 50%;\n  text-align: center;\n}\n\n.ltn-avail > tr > td:last-child,\n.ltn-avail-block > tr > td:last-child\n{\n  text-align: left;\n}\n\n.ltn-avail > tr > td,\n.ltn-avail-block > tr > td {\n  text-align: right;\n  padding-left: 5px;\n}\n\n.ltn-avail-block > tr > th {\n  padding-top: 15px;\n  padding-bottom: 10px;\n}\n\n.ltn-tree__header h3 {\n  padding-top: 4em;\n  padding-bottom: 1em;\n  border-bottom: 1px solid white;\n}\n\n.ltn-tree__tile {\n  padding-bottom: 5px;\n  padding-top: 5px;\n  border-bottom: 1px solid white;\n}\n\n.ltn-tree__tile--naughty {\n  background-color: #420000;\n}\n\n.prod-stats td, .prod-stats th {\n  text-align: right;\n}\n\n.gps-link-button img {\n  max-width: 18px;\n  max-height: 25px;\n  cursor: pointer;\n  margin-right: 8px;\n}\n\n.slippy {\n  height: 80vh;\n  width: 100%;\n  background: black;\n}\n\n.slippy--time-range {\n  width: 100%;\n  padding: 3px;\n  margin-top: 1em;\n}\n\n.slippy--time-range ol {\n  width: 100%;\n  list-style-type: none;\n  padding-left: 0;\n  margin-bottom: 0;\n}\n\n.slippy--time-range ol li {\n  display: inline-block;\n  border: 1px solid #888;\n  border-radius: 3px;\n  background-color: white;\n\n}\n\n.slippy--time-range-bar li {\n  cursor: pointer;\n  user-select: none;\n  overflow: hidden;\n  text-align: center;\n}\n\n.slippy--time-range-legend {\n  color: black;\n  text-align: center;\n  margin-top: 0;\n  white-space: nowrap;\n  text-overflow: clip;\n}\n\n.slippy--time-range-help {\n  margin-top: 1em;\n}\n\n.slippy--time-range-table td {\n  vertical-align: middle;\n}\n\n.slippy--time-range-table td:nth-child(1) {\n  white-space: nowrap;\n}\n\n.slippy--time-range-table td:nth-child(3),\n.slippy--time-range-table th:nth-child(3) {\n  text-align: right;\n}\n\n.slippy--time-range-table--picked {\n  background-color: #3a4753;\n}\n\n.slippy--time-range-help--instructions div {\n  vertical-align: middle;\n  margin: auto;\n  text-align: center;\n}\n\n\n.block-thumb {\n  height: 140px;\n  width: 204px;\n  background: black;\n  cursor: pointer;\n}\n\n.amount {\n  display: inline-block;\n  text-align: right;\n  min-width: 2.2em;\n}\n\n.ul-none {\n  list-style-type: none;\n  padding-left: 0;\n}\n\n.avail-icon {\n  width: 24px;\n  height: 24px;\n  vertical-align: middle;\n  margin-right: 0.5em;\n}\n\n.big-boy {\n  height: 8em;\n  font-family: monospace;\n  font-size: small;\n}\n\n.current-chain-ul > li {\n  margin-top: 1em;\n}\n\n.chestify-summary > thead > tr > th:nth-child(2),\n.chestify-summary > thead > tr > th:nth-child(3),\n.chestify-summary > tbody > tr > td:nth-child(2),\n.chestify-summary > tbody > tr > td:nth-child(3),\n.chestify-summary > tbody > tr > td:nth-child(4)\n{\n  text-align: right;\n}\n\n.chestify-banned > td {\n  text-decoration: line-through;\n  font-style: italic;\n}\n\n.plan-number-table {\n  width: 100%;\n}\n\n.plan-table-col {\n  min-height: 18em;\n}\n\n.plan-number-table > tbody > tr > td:nth-child(1)\n{\n  text-align: right;\n}\n\n.plan-number-table > tbody > tr > td:nth-child(3)\n{\n  text-align: right;\n  font-size: small;\n}\n\n.plan-number-table--risky {\n  color: #bebe00;\n}\n\n.plan-number-table--naughty {\n  color: #be0000;\n}\n\n.busy-trains-table tr td {\n  text-align: right;\n}\n\n.busy-trains-table tr td:nth-child(1) {\n  text-align: left;\n}\n\n.busy-trains-table--risky {\n  background-color: #440 !important;\n}\n\n.busy-trains-table--naughty {\n  background-color: #400 !important;\n}\n\n.station-config tr td {\n  text-align: right;\n}\n\n.station-config tr td:nth-child(1) {\n  text-align: left;\n}\n\n.station-config th {\n  top:0;\n  background: var(--bs-body-bg);\n  position: sticky;\n}\n\n.station-config--naughty {\n  background-color: #400 !important;\n}\n\n.station-config-sorter {\n  cursor: pointer;\n}\n\n.station-config label {\n  white-space: nowrap;\n}\n\n.station-config-sorter:hover {\n  text-decoration: underline;\n}\n\n.station-config-sorter-active {\n  text-decoration: underline;\n}\n\n.build-speed th, .build-speed td {\n  text-align: right;\n  padding-left: 0.3em;\n}\n\n.action-pill {\n  color: inherit;\n  text-decoration: none;\n  background: #333;\n}\n\n.date-picker-form {\n  margin: 1em;\n}\n\n.date-picker-form label {\n  margin-right: 0.5em;\n}\n\n.date-picker-input {\n  padding: 0.375rem 0.75rem;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: var(--bs-body-color);\n  background-color: var(--bs-form-control-bg);\n  background-clip: padding-box;\n  border: var(--bs-border-width) solid var(--bs-border-color);\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  border-radius: 0.375rem;\n  transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;\n  margin-left: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
